var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FMS-main"},[_c('div',{staticClass:"top-container"}),_c('div',{staticClass:"bottom-container"},[_c('GanttChart')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }